// extracted by mini-css-extract-plugin
export var container = "style-module--container--15f90";
export var desc = "style-module--desc--f9301";
export var duration = "style-module--duration--0ade8";
export var themes = "style-module--themes--d3abf";